module.exports = __webpack_public_path__ + "img/reason2.dd54c61f.png";